import { MultiFeedTeaseColumn } from "design-system/components/blocks/multi-feed-tease-row/multi-feed-tease-row";
import { createContentfulProps } from "frontend/contentful/lib/create-contentful-props";
import { MultiFeedTeaseColumnEntry } from "frontend/contentful/schema/primitives";
import { useContentful } from "frontend/hooks/use-contentful";

export const createMultiFeedTeaseColumnProps = createContentfulProps<
  MultiFeedTeaseColumnEntry,
  MultiFeedTeaseColumn
>(({ entry, createEditAttributes }) => {
  const { getEntryUrl, getEntry } = useContentful();

  const props: MultiFeedTeaseColumn = {
    articles: [],
    editAttributes: {
      title: createEditAttributes({ entry, fieldId: "title" }),
      articles: createEditAttributes({ entry: entry.fields.query }),
      cta: createEditAttributes({
        entry: entry.fields.ctaLink,
        fieldId: "text",
      }),
    },
  };

  if (entry.fields?.title) {
    props.header = {
      title: entry.fields.title,
      isSmall: false,
    };
  }

  const ctaLink = getEntry(entry.fields.ctaLink);

  if (ctaLink?.fields?.text) {
    props.cta = {
      linkText: ctaLink?.fields.text,
      link: getEntryUrl(ctaLink),
      ariaLabel: ctaLink?.fields.ariaLabel,
    };
  }

  return props;
});
